export const recommenderIdentification = {
  'Exclusive offer!': '¡Oferta exclusiva!',
};
